import { useLang, buildWhatsAppUrl } from "../i18n";
import { useEffect, useState } from "react";

// Inline WhatsApp glyph (mono) so we don't depend on brand icon libs
function WhatsAppGlyph(props) {
  return (
    <svg viewBox="0 0 32 32" fill="currentColor" aria-hidden="true" {...props}>
      <path d="M19.11 17.21c-.27-.13-1.58-.78-1.82-.87-.24-.09-.42-.13-.6.13-.18.27-.69.87-.84 1.05-.16.18-.31.2-.58.07-.27-.13-1.13-.42-2.15-1.33-.79-.7-1.33-1.57-1.49-1.84-.16-.27-.02-.41.12-.55.12-.12.27-.31.4-.46.13-.16.18-.27.27-.45.09-.18.04-.34-.02-.47-.07-.13-.6-1.45-.82-1.99-.22-.52-.45-.45-.6-.45-.16 0-.34-.02-.52-.02-.18 0-.47.07-.72.34-.25.27-.95.93-.95 2.27 0 1.34.97 2.63 1.11 2.81.13.18 1.91 2.92 4.62 4.09.65.28 1.16.45 1.55.58.65.21 1.24.18 1.71.11.52-.08 1.58-.65 1.81-1.27.22-.62.22-1.15.16-1.27-.07-.12-.24-.18-.51-.31zM16.02 5.33c-5.89 0-10.67 4.79-10.67 10.68 0 1.88.49 3.7 1.43 5.32L5 27l5.88-1.55a10.65 10.65 0 0 0 5.13 1.31h.01c5.89 0 10.67-4.79 10.67-10.68 0-2.85-1.11-5.53-3.13-7.55a10.6 10.6 0 0 0-7.54-3.2zm0 19.55h-.01a8.81 8.81 0 0 1-4.49-1.23l-.32-.19-3.49.92.93-3.4-.21-.35a8.83 8.83 0 0 1-1.35-4.69c0-4.88 3.98-8.85 8.86-8.85 2.37 0 4.6.92 6.28 2.59a8.81 8.81 0 0 1 2.6 6.27c0 4.88-3.98 8.86-8.8 8.86z"/>
    </svg>
  );
}

export default function WhatsAppFloat() {
  const { t } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      data-testid="whatsapp-float"
      aria-label="Book on WhatsApp"
      href={buildWhatsAppUrl(t.whatsapp_pretext)}
      target="_blank"
      rel="noopener noreferrer"
      className={`fixed bottom-5 right-5 md:bottom-7 md:right-7 z-50 transition-all duration-500 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      <span className="relative flex items-center gap-3">
        <span className="hidden md:inline-block bg-black/80 border border-white/10 backdrop-blur-md text-white text-xs uppercase tracking-[0.22em] px-4 py-2">
          {t.nav.book}
        </span>
        <span
          className="wa-pulse flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full shadow-2xl"
          style={{ background: "hsl(var(--red))" }}
        >
          <WhatsAppGlyph className="w-7 h-7 md:w-8 md:h-8 text-white" />
        </span>
      </span>
    </a>
  );
}
